import { apiClient } from './client';
// Client Company API functions
export const clientCompanyApi = {
    // Get company by ID
    getById: (id) => apiClient.get(`/api/clientcompanies/${id}`),
    // Update company
    update: (clientCompanyId, company) => apiClient.put(`/api/ClientCompanies/${clientCompanyId}`, company),
    // Get customers managed by a company (full view DTOs with workspaces)
    getCustomersManagedByCompany: (companyId) => apiClient.get(`/api/ClientCompanies/${companyId}/Customers`),
    // Create a new client company (returns ClientCompanyViewDto)
    create: (managingClientCompanyId, payload) => apiClient.post(`/api/ClientCompanies/${managingClientCompanyId}/Customers`, payload),
};
